"use client"

import { useEffect } from "react"

export function HubSpotMeetings({ meetingUrl }: { meetingUrl: string }) {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <div
      className="meetings-iframe-container"
      data-src={`${meetingUrl}?embed=true`}
      style={{ minHeight: '650px' }}
    />
  )
}
